import { useState } from 'react';
import { useMst } from '../../models/WithWineState';
import { StoreFilterDefaultProps } from '../../types/StoreFilterProps';
import { parseQueryString } from '../parseQueryString';
import { StoreFilterKeys } from '../../models/StoreFilter';

export const useStoreFilterDefaults = (
  defaultfilter?: StoreFilterDefaultProps,
  sort?: string,
) => {
  const state = useMst();

  const [parsedDefaults, setParsedDefaults] = useState(
    (): null | (Record<StoreFilterKeys, string[]> & Record<'sort', string>) => {
      const result: Record<keyof StoreFilterDefaultProps, string[]> = {
        winetype: [],
        variety: [],
        availability: [],
        list: [],
        region: [],
      };

      let sortResult = '';

      if (typeof window !== 'undefined' && window.location.search.length) {
        parseQueryString(window.location.search.substring(1)).forEach((f) => {
          const lowercaseKey = f.key.toLowerCase();
          if (
            Object.prototype.hasOwnProperty.call(result, lowercaseKey) &&
            f.value
          ) {
            result[lowercaseKey as keyof StoreFilterDefaultProps].push(
              ...f.value.split('|'),
            );
          } else if (lowercaseKey === 'sort' && f.value) {
            sortResult = f.value;
          }
        });
      }

      const defaultFilterProps: (keyof StoreFilterDefaultProps)[] = [
        'winetype',
        'list',
        'availability',
        'variety',
        'region',
      ];

      if (defaultfilter) {
        defaultFilterProps.forEach((f) => {
          if (defaultfilter[f] && result[f].length === 0) {
            result[f].push(...(defaultfilter[f] ?? '').split('|'));
          }
        });
      }

      if (result['winetype'].length === 0) {
        result['winetype'].push('selectAll');
      }
      if (result['list'].length === 0) {
        result['list'].push('selectAll');
      }
      if (result['availability'].length === 0) {
        result['availability'].push('availableToBuy');
      }
      if (result['variety'].length === 0) {
        result['variety'].push('selectAll');
      }
      if (result['region'].length === 0) {
        result['region'].push('selectAll');
      }

      if (!sortResult && sort) {
        sortResult = sort;
      }

      return {
        wineType: result.winetype,
        availability: result.availability,
        list: result.list,
        region: result.region,
        variety: result.variety,
        sort: sortResult,
      };
    },
  );

  if (parsedDefaults) {
    state.widgets.storeFilter.showOnly(parsedDefaults);
    if (parsedDefaults.sort) {
      state.widgets.storeFilter.setSortString(parsedDefaults.sort);
    }
    setParsedDefaults(null);
  }
};
